import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { getCurrentRegion } from '../../order/order'
import ImmutablePropTypes from 'react-immutable-proptypes'
import styles from './css/OptionalMessage.scss'

class OptionalMessage extends Component {
    static propTypes = {
        region: ImmutablePropTypes.map.isRequired,
        tenant: ImmutablePropTypes.map.isRequired,
        session: ImmutablePropTypes.map.isRequired,
        order: ImmutablePropTypes.map.isRequired,
        slug: PropTypes.string.isRequired,
    }

    constructor(props) {
        super(props);
        const { region, tenant, session, slug, order } = this.props

        if (!tenant || !region || !order) {
            console.warn('OptionalMessage: no tenant or region')
        }

        const currentLocale = session.get('locale', false)
        const serviceId = order.get('service', false)

        const serviceString = serviceId ? "service_" + serviceId : false

        this.hintSlug = serviceString
            ? `${tenant.get('code_part')}.${region.get('isoCode')}.${serviceString}.${slug}`.toLowerCase()
            : `${tenant.get('code_part')}.${region.get('isoCode')}.${slug}`.toLowerCase()

        this.hasTranslation = !!window.LOCALES[currentLocale].messages[this.hintSlug]

        if (!this.hasTranslation) {
            console.warn('OptionalMessage: no translation found for slug', this.hintSlug)
        }
    }


    render () {
        return this.hasTranslation ? (
            <div className={styles.optionalMessage}>
                <FormattedMessage
                    id={this.hintSlug}
                />
            </div>
        ) : null
    }
}

export default connect(function (state) {
    return {
        region: getCurrentRegion(state),
        tenant: state.tenant,
        session: state.session,
        order: state.order,
    }
})(OptionalMessage)

